const USER_KEY = "user";

export const setLoggedInUser = (user) => {
  localStorage.setItem(USER_KEY, JSON.stringify(user));
};

export const getLoggedInUser = () => {
  const data = localStorage.getItem(USER_KEY);
  return data ? JSON.parse(data) : null;
};

export const removeLoggedInUser = () => {
  localStorage.removeItem(USER_KEY);
};
